export default '/build/03a69a7d.png'